export default __webpack_public_path__ + "static/media/compas_create_multi_perimeters.63d1dda8.gif";